import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_ALL_POST_TAGS = gql`
  query Get($type: String!) {
    getAllPostTags(search: $type) {
      tags
    }
  }
`;

const getAllPostTags = async (type) => {
  try {
    const result = await client
      .query({
        query: GET_ALL_POST_TAGS,
        variables: { type },
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
        fetchResults: true,
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { getAllPostTags: postsByTypeData },
    } = result;

    if (postsByTypeData) {
      return postsByTypeData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getAllPostTags = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getAllPostTags Error: ${error}`);
    return null;
  }
};

export default getAllPostTags;
